import { forwardRef, HTMLAttributes, ReactNode } from 'react';
import { cn } from './cn';

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(function EmptyState(
  { icon, title, description, action, className, ...rest },
  ref
) {
  return (
    <div ref={ref} data-tss-ui="" className={cn('tss-empty', className)} role="status" {...rest}>
      {icon && (
        <div className="tss-empty__icon" aria-hidden="true">
          {icon}
        </div>
      )}
      <h3 className="tss-empty__title">{title}</h3>
      {description && <p className="tss-empty__description">{description}</p>}
      {action && <div className="tss-empty__action">{action}</div>}
    </div>
  );
});
